import wixWindow from 'wix-window';

$w.onReady(function () {
	initPage();
});

async function initPage() {
	try {
		const product = await $w('#productPage').getProduct();
		if (!product.inStock) {
			$w('#backInStockButton').show();
			$w("#backInStockButton").onClick((event) => {
				wixWindow.openLightbox('Enter Details', { 'productId': product._id });
			});
		}
	} catch (error) {
		console.error('product page -> initPage error ', error);
		return false;
	}
}